class RechargeOptions extends HTMLElement {
	constructor() {
		super();

		this.options = this.getAllOptions();
		this.currentOption = null;
		this.cartParam = {};
		this.discountPrice = null;
		this.quantity = this.querySelector('.quantity__input');
		this.buttonAddToCard = this.querySelector("[data-add-recharge-button]");
		this.AjaxCart = document.querySelector('ajax-cart');
		this.product = this.getProductJson();
		this.addEventListener('change', this.onOptionChange);
		this.discounts = this.createDiscountArray();
		this.buttonAddToCard.addEventListener('click', this.onAddToCart.bind(this));
		this.onOptionChange();

		// if (this.discounts.length > 0) {
		// 	this.quantity.addEventListener('change', this.onQuantityChange.bind(this));
		// }
		this.quantity.addEventListener('change', this.onQuantityChange.bind(this));
		const form = this.nextElementSibling;
        if (form.dataset.type === 'add-to-cart-form') {
            this.setSellingPlanId(form)
        }
	}
	onOptionChange() {
		this.updateCurrentOption();
		if (!this.checkOneTimeSubscription()) {
			this.discountPrice = null;

		}else {
			this.discountPrice = this.querySelector("[data-dynamic-price]").textContent;
		}

		this.updateProductInfo();
		this.saveCartParam();
		this.updateAddToCartButton();
        this.updateDynamicForm();
	}

	onQuantityChange(event) {

		if (this.checkOneTimeSubscription()) {
			this.setDiscount(event?.target?.value);
		}
	}

	setDiscount(quantity) {
		let priceContainer = this.querySelector('.recharge-options__one-time').querySelector('.recharge-option__price');

		this.discounts = this.discounts.sort(function (a, b) {
			return a.quantity - b.quantity;
		});

		let discount = this.discounts.reverse().find(function(el) {
			return (parseInt(quantity) >= parseInt(el.quantity));
		});

		this.changePrice(discount,quantity);

		let element = document.createElement("span");
		priceContainer.querySelector('.bulk-option__price-discount')?.remove();
		if (discount) {
			element.classList.add('bulk-option__price-discount');
			element.innerText = `SAVE ${discount.discount}%`;
			priceContainer.prepend(element);
		} else  {
			priceContainer.querySelector('.bulk-option__price-discount')?.remove();
		}
	}

	changePrice(discount,quantity) {

		if (!quantity) {
			return
		}

		let price_container = this.querySelector('[data-dynamic-price]');
		let price_container_old = this.querySelector('[data-old-price]');
		let price = this.product.price;

		let price_container_compare = this.querySelector('[data-compare-price]');
		let price_compare = this.product.compare_at_price;
		price_container_old.innerText = this.formatMoney(price * quantity,'${{amount}}');

		if (discount) {
			let percent = 1 - (discount.discount * 0.01);
			price = price * percent;
			price_container_old.style.display = "block";
			if( price_container_compare){

				price_container_compare.style.display = "none";
			}
		} else if(price_container_compare){
			price_container_compare.style.display = "block";
			price_container_old.style.display = "none";
			price_container_compare.innerText =  this.formatMoney(price_compare * quantity,'${{amount}}');

		} else {
			price_container_old.style.display = "none";

		}

		price = quantity * price;
		this.discountPrice = this.formatMoney(price,'${{amount}}');
		price_container.innerText = this.formatMoney(price,'${{amount}}');
	}

	createDiscountArray() {
		let discounts = [];
		this.product.tags.forEach(tag => {
			if (tag.includes('discount_')) {
				let t = tag.split('_')
				let quantity = t[1];
				let percent = t[2];
				if (percent && percent) {
					discounts.push({
						quantity: quantity,
						discount: percent
					})
				}
			}
		})
		return discounts;
	}

	onAddToCart() {
		this.saveCartParam();

		const sections = this.AjaxCart.getSectionsToRender().map((section) => section.id);

		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({items:[this.cartParam],sections: sections})
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			}).then((response) => {
		 		if (response.items.length > 0 && response.items[0].selling_plan_allocation) {
                    const qvModal = document.getElementById('quick-view-modal');
                    const displayed = sessionStorage.getItem('qv-displayed') === 'true';
                    if(qvModal && !displayed) {
                        qvModal.removeAttribute('hidden');
                    }
                }
				
			this.AjaxCart.open();
			this.AjaxCart.renderContents(response);
		});


	}

	updateCurrentOption() {
		this.currentOption = Array.from(this.options).find((radio) => radio.checked);
	}

	updateProductInfo() {
		this.info = Object.assign({}, this.currentOption.dataset)
	}

    setSellingPlanId(form){
        const sellPlanInput = form.querySelector('input[name="selling_plan"]');
        const id = this.currentOption.dataset.sellingplan;
        sellPlanInput.value = id ? id : '';
    }
    updateDynamicForm() {
        const form = this.nextElementSibling;
        if (!form || form.dataset.type !== 'add-to-cart-form') {
            return;
        }


        const idInput = form.querySelector('input[name="id"]');
        const productInput = form.querySelector('input[name="product-id"]');

        if (this.currentOption.classList.contains('option-subscription')) {
            const subProductId = this.currentOption.id;
            idInput.setAttribute('data-productid', subProductId);
            productInput.value = subProductId;
        } else {
            const productId = this.dataset.proudct_id;
            idInput.setAttribute('data-productid', productId);
            productInput.value = productId;
        }
        this.setSellingPlanId(form);
        idInput.value = this.currentOption.dataset.id;
    }
	updateAddToCartButton() {

		// RE-DEV
		const buttonInfo = this.buttonAddToCard.querySelector('[data-recharge-info]');

		let text_b = '';
		if(this.info.customTextForAddToCart && this.info.customTextForAddToCart !== '') {
			text_b = this.info.customTextForAddToCart;
		} else {
			text_b = this.info.shipping_interval_frequency + '&nbsp;' + this.info.shipping_interval_unit_type
		}

		let price = this.discountPrice || this.info.price;

		if (!this.checkOneTimeSubscription())
			buttonInfo.innerHTML = `&nbsp;-&nbsp;${price}&nbsp;${text_b}`
		else if(this.info.price)
			buttonInfo.innerHTML = '&nbsp;-&nbsp;' + price;
		else
			buttonInfo.innerHTML = '';
	}

	saveCartParam() {
		this.checkOneTimeSubscription() ?
			this.saveOneTime() : this.saveSubscription();
	}

	saveOneTime() {
		this.cartParam = {
			id: +this.currentOption.dataset.id,
			quantity: +this.getOneTimeQuantity()
		}
	}

	saveSubscription() {

		const {
			shipping_interval_frequency,
			shipping_interval_unit_type,
			sellingplan,
			id,
		} = this.currentOption.dataset;


		this.cartParam = {
			id: +id,
			quantity: 1,
			selling_plan:sellingplan,
			properties: {
				'shipping_interval_unit_type': shipping_interval_unit_type,
				'shipping_interval_frequency': shipping_interval_frequency
			}
		}
	}

	checkOneTimeSubscription() {
		return this.currentOption.dataset.selectType === 'on-time';
	}

	getAllOptions() {
		return Array.from(this.querySelectorAll('input[name="recharge-option"]'));
	}

	getOneTimeQuantity() {
		return this.quantity.value;
	}

	getProductJson() {
		this.product = this.product || JSON.parse(this.querySelector('[data-recharge-product]').textContent);
		return this.product;
	}

	formatMoney(cents, format) {
		if (typeof cents == 'string') { cents = cents.replace('.',''); }
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || this.money_format);

		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal   = defaultOption(decimal, '.');

			if (isNaN(number) || number == null) { return 0; }

			number = (number/100.0).toFixed(precision);

			var parts   = number.split('.'),
				dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
				cents   = parts[1] ? (decimal + parts[1]) : '';

			return dollars + cents;
		}

		switch(formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	};

}


customElements.define('recharge-options', RechargeOptions);
